export const LAUNCH_CUSTOMERS_CREATE_LABEL_MODAL = 'LAUNCH_CUSTOMERS_CREATE_LABEL_MODAL';
export const CLOSE_CUSTOMERS_CREATE_LABEL_MODAL = 'CLOSE_CUSTOMERS_CREATE_LABEL_MODAL';
export const CUSTOMERS_CREATE_LABEL_EMAIL_UPDATE = 'CUSTOMERS_CREATE_LABEL_EMAIL_UPDATE';
export const CUSTOMERS_CREATE_LABEL_ADDRESS_UPDATE = 'CUSTOMERS_CREATE_LABEL_ADDRESS_UPDATE';

export const launchCustomersCreateLabelModal = () => ({
  type: LAUNCH_CUSTOMERS_CREATE_LABEL_MODAL,
});

export const closeCustomersCreateLabelModal = () => ({
  type: CLOSE_CUSTOMERS_CREATE_LABEL_MODAL,
});

export const CUSTOMER_CREATE_LABEL_CONFIGURE_RATES_MODEL = 'CUSTOMER_CREATE_LABEL_CONFIGURE_RATES_MODEL';
export const updateConfigureRatesModel = (updatePayload) => ({
  type: CUSTOMER_CREATE_LABEL_CONFIGURE_RATES_MODEL,
  updatePayload,
});

export const UPDATE_CUSTOMER_CREATE_LABEL_FROM_SHIP_FROM_ID = 'UPDATE_CUSTOMER_CREATE_LABEL_FROM_SHIP_FROM_ID';
export const updateCustomerCreateLabelShipFromId = (shipFromId) => ({
  type: UPDATE_CUSTOMER_CREATE_LABEL_FROM_SHIP_FROM_ID,
  shipFromId,
});
